var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTakephoto(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16517_2107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 2.64999H11.3181C11.1941 2.64146 11.0753 2.59633 10.9769 2.52032C10.8785 2.44432 10.8048 2.34086 10.7651 2.22299L10.3311 0.822983C10.2915 0.705115 10.2178 0.601651 10.1194 0.52565C10.0209 0.449649 9.9022 0.404534 9.77813 0.395996H5.01814C4.89404 0.404404 4.77522 0.449462 4.67677 0.525482C4.57832 0.601502 4.50466 0.705045 4.46513 0.822983L4.03114 2.22299C3.9915 2.34086 3.91781 2.44432 3.81938 2.52032C3.72095 2.59633 3.60219 2.64146 3.47813 2.64999H1.79814C1.41413 2.66485 1.05153 2.83081 0.789318 3.11176C0.527105 3.3927 0.3865 3.76587 0.398129 4.14999V10.9C0.3865 11.2841 0.527105 11.6573 0.789318 11.9382C1.05153 12.2192 1.41413 12.3851 1.79814 12.4H12.9981C13.3821 12.3851 13.7447 12.2192 14.007 11.9382C14.2692 11.6573 14.4098 11.2841 14.3981 10.9V4.14999C14.4098 3.7662 14.2694 3.39333 14.0077 3.11244C13.7459 2.83156 13.3838 2.66537 13.0001 2.64999Z",
    stroke: "#003EBF",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7001 9.49999C9.13604 9.49999 10.3001 8.33593 10.3001 6.89999C10.3001 5.46405 9.13604 4.29999 7.7001 4.29999C6.26416 4.29999 5.1001 5.46405 5.1001 6.89999C5.1001 8.33593 6.26416 9.49999 7.7001 9.49999Z",
    stroke: "#003EBF",
    strokeWidth: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16517_2107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.8,
    height: 12.8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakephoto);
export default __webpack_public_path__ + "static/media/takephoto.14f40827e7436cbea38b6d95495b98b8.svg";
export { ForwardRef as ReactComponent };